exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".data-row[data-v-ff071da0] {\n  border: solid 1px #8f8f8f;\n  border-bottom: none;\n}\n.data-row[data-v-ff071da0]:last-child {\n  border: solid 1px #8f8f8f;\n}\n.score[data-v-ff071da0]:not(:last-child):after {\n  content: \", \";\n}\n.line[data-v-ff071da0] {\n  border: solid 1px #8f8f8f;\n}\ndiv.flagged[data-v-ff071da0] {\n  background-color: #fcf8ed;\n}\nsmall.flagged[data-v-ff071da0] {\n  color: #ff0000;\n  font-weight: 600;\n}", ""]);

// exports
